import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {Config} from '../../Config'
import moment from "moment-timezone";
import * as Utils from "../../inc/Utils";

export default function Rebrandly() {
    let id = 1;

    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'อัพเดตข้อมูล';
    let btnTextLoading = 'กำลังอัพเดต..';
    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');
    let [statusChecked, setStatusChecked] = React.useState(false);
    let [rebrandlyAccount, setRebrandlyAccount] = React.useState(false);

    let refName = React.useRef();
    let refApikey = React.useRef(); 
    let refEndpoint = React.useRef();
    let refDomain = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                const resView = await getView();
                setData(resView);
                setStatusChecked(resView.status===1);

                const resAcc = await getRebrandlyAccount(resView.apiKey);
                setRebrandlyAccount(resAcc);
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.url.API_URL +'/api/rebrandly/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getRebrandlyAccount(apiKey) {
        if(apiKey) {
            const response = await fetch('https://api.rebrandly.com/v1/account', {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'apikey': apiKey
                }
            });

            if(response.ok) {
                return response.json();
            }
            else {
                return response.json().then(err => Promise.reject(err));
            }
        }
    }

    const onUpdate = () => {
        let name = refName.current.value;
        let apikey = refApikey.current.value; 
        let endpoint = refEndpoint.current.value;
        let domain = refDomain.current.value;
        if(!name) {
            toast.error("กรุณาระบุ ชื่อ");
            refName.current.focus();
        }
        else if(!apikey) {
            toast.error("กรุณาระบุ API KEY");
            refApikey.current.focus();
        }
        else if(!endpoint) {
            toast.error("กรุณาระบุ Endpoint");
            refEndpoint.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                id: data.id,
                                name: name,
                                domain: domain,
                                apikey: apikey,
                                endpoint: endpoint,
                                status: statusChecked[0].checked ? 1:0,
                                updatedBy: userId,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                            };
                            fetch(Config.url.API_URL +'/api/rebrandly/update', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("อัพเดตข้อมูลเรียบร้อย");
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    if(data) {
        refName.current.value = data.name;
        refApikey.current.value = data.apiKey;
        refEndpoint.current.value = data.endpoint;
        refDomain.current.value = data.domain;
    }

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Rebrandly</div>
                    <span className="ms-1">/</span> <span className="text-muted">Edit</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">ชื่อ <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="apikey" className="form-label">API KEY <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="apikey" ref={refApikey} maxLength={200} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="endpoint" className="form-label">Endpoint <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="endpoint" ref={refEndpoint} maxLength={200} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="domain" className="form-label">Domain</label>
                                <input type="text" className="form-control" id="domain" ref={refDomain} maxLength={200} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">สถานะ</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" checked={statusChecked} onChange={e => {setStatusChecked(e.target.checked)}} disabled={!roles.isEdit(Utils.MENU_REBRANDLY)} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>
                            {
                                roles.isEdit(Utils.MENU_REBRANDLY) ?
                                    <div className="col-12">
                                        <button type="button" className="btn btn-primary" onClick={onUpdate}><span
                                            className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                        <Toaster position="bottom-right" />
                                    </div> : ''
                            }
                        </form>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="bg-yellow-light rounded p-2">
                            <label htmlFor="name" className="form-label">Account Info</label>
                            <ul className="list-group">
                                <li className="list-group-item">FullName : {rebrandlyAccount.fullName}</li>
                                <li className="list-group-item">Email : {rebrandlyAccount.email}</li>
                                <li className="list-group-item">Clicks : {rebrandlyAccount.clicks}</li>
                                <li className="list-group-item">LastClickAt : {rebrandlyAccount.lastClickAt}</li>
                                <li className="list-group-item">Links limits : {rebrandlyAccount.subscription ? rebrandlyAccount.subscription.limits.cycle["links-classic"].used + '/' + rebrandlyAccount.subscription.limits.cycle["links-classic"].included :''}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
} 